import React from 'react';
import { CardChangeButton } from '../../../../../../../components/Card';
import { useSetModalVisible } from '../../services/modalState';

const LifeCycleChangeBtn = () => {
  const setModalVisible = useSetModalVisible();

  return <CardChangeButton onClick={() => setModalVisible(true)} />;
};

export default LifeCycleChangeBtn;
